<template>
  <div
    class="row"
    :class="[description ? 'tooltip-mine-dynamic' : 'tooltip-mine']"
  >
    <div class="col-lg-1 col-2 cursor-pointer d-table" v-if="!description">
      <span class="icon-prev d-table-cell align-middle" @click="goPrevious()">
        <font-awesome-icon
          class="cursor-pointer"
          :icon="['fas', 'angle-left']"
        />
      </span>
    </div>
    <div class="col img-info" v-if="!description">
      <img
        :src="baseImageUrl + data[index].image"
        class="border-img"
        height="40"
        width="40"
      />
      <p class="jewel-descr text-uppercase">{{ $t(type + "-information") }}</p>
      <span class="jewel-descr" v-if="data[index].description">{{
        data[index].description
      }}</span>
    </div>
    <div class="col img-info d-table" v-if="description">
      <span class="jewel-descr d-table-cell align-middle">{{
        description
      }}</span>
    </div>
    <div class="col-lg-1 col-2 cursor-pointer d-table" v-if="!description">
      <span class="icon-next d-table-cell align-middle" @click="goNext()">
        <font-awesome-icon
          class="cursor-pointer"
          :icon="['fas', 'angle-right']"
        />
      </span>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  Swiper as SwiperClass,
  Pagination,
  Navigation,
} from "swiper/swiper.esm";
import getAwesomeSwiper from "vue-awesome-swiper/dist/exporter";

// import style
import "swiper/swiper-bundle.css";
import { mapState } from "vuex";
import { directive } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";

SwiperClass.use([Pagination, Navigation]);
Vue.use(getAwesomeSwiper(SwiperClass));

export default {
  name: "JewelDescriptionTooltip",
  directives: {
    swiper: directive,
  },
  props: ["data", "description", "type"],

  data() {
    return {
      index: 0,
      baseImageUrl: process.env.VUE_APP_IMAGE_PATH,

      swiperOptions: {
        loop: false,
        centeredSlides: true,
        centeredSlidesBounds: true,
        slidesPerView: 1,
        spaceBetween: 40,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        // Some Swiper option/callback...
      },
    };
  },
  computed: mapState({
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  }),
  methods: {
    goPrevious() {
      if (this.index > 0) {
        this.index = this.index - 1;
      }
    },
    goNext() {
      if (this.index < this.data.length - 1) {
        this.index = this.index + 1;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">


.tooltip-mine-dynamic {
  min-width: 300px;
  max-width: 300px;
  min-height: 30px;
  max-height: 150px;
}
.tooltip-mine {
  min-width: 300px;
  max-width: 300px;
  height: 150px;
}
.jewel-descr {
  font-size: 12px;
  color: var(--primary-color-1);
}
.swiper-slide {
  // width: 100% !important;
  // height: 250px;
}

.swiper-button-next,
.swiper-button-prev {
  --swiper-navigation-color: #ccc;
  --swiper-navigation-size: 12px;
  &:hover {
    --swiper-navigation-color: #666;
  }
}

.carousel-inner {
  text-align: center;
}

.icon-next,
.icon-prev {
  color: #ccc;
  font-size: 20px;
}

.img-info {
  text-align: center;
}
</style>
